"use client";
import React, { SetStateAction, Dispatch } from "react";
import { IVariantDetailsPrice } from "../CustomCard/CustomCard.types";
import CustomCard from "../CustomCard";
import styles from "./CardListPrice.module.scss";
import Image from "next/image";
import assetLoader from "@utils/internalImageLoder";
import { PageType } from "@constants/pageTypes";

interface CardListProps {
  variants: IVariantDetailsPrice[];
  isLoggedIn: boolean;
  city: any;
  brandName: string;
  modelName: string;
  pageType?: PageType;
  carAvailability?: string;
  savingBalance?: any;
  expandedIndex: number | null;
  showMore: boolean;
  setShowMore: Dispatch<SetStateAction<boolean>>;
  jsEnabled: boolean;
  variantsToShow: IVariantDetailsPrice[];
  handleToggle: (index: number) => void;
  firstVariantPriceBreakup?: any;
}

export default function CardList({
  variants,
  isLoggedIn,
  city,
  brandName,
  modelName,
  pageType,
  carAvailability,
  savingBalance,
  expandedIndex,
  showMore,
  setShowMore,
  jsEnabled,
  variantsToShow,
  handleToggle,
  firstVariantPriceBreakup,
}: CardListProps) {
  return (
    <div className={styles.container}>
      <div
        className={`${styles.cardWrapper} ${
          jsEnabled && !showMore ? styles.hideExtraVariants : ""
        }`}
      >
        {variantsToShow.map((variant, index) => (
          <div
            key={variant.slug}
            className={
              jsEnabled && index >= 4 && !showMore ? styles.hiddenVariant : ""
            }
          >
            <CustomCard
              data={variant}
              isExpanded={expandedIndex === index}
              onToggle={() => handleToggle(index)}
              isLoggedIn={isLoggedIn}
              city={city}
              brandName={brandName}
              modelName={modelName}
              isSellable={variant.status === "sellable"}
              pageType={pageType}
              carAvailability={carAvailability}
              savingBalance={savingBalance}
              firstVariantPriceBreakup={
                index === 0 ? firstVariantPriceBreakup : undefined
              }
              expandedIndex={expandedIndex ?? 0}
            />
          </div>
        ))}
      </div>
      {jsEnabled && variants.length > 4 && (
        <div
          className={styles.viewMoreLink}
          onClick={() => setShowMore(!showMore)}
        >
          {showMore
            ? `View less variants`
            : `View ${variants.length - 4} more variants`}
          <Image
            src={`${assetLoader()}/icons/Chevron_down.svg`}
            alt="arrow-right"
            width={24}
            height={24}
            className={`${showMore ? styles.iconRotate : ""}`}
          />
        </div>
      )}
    </div>
  );
}
